import { ImageWithPlaceholder } from '@wbk/ui';
import { Marquee } from '@/components/ui/Marquee';

const MarqueeSection = () => {
  const images = [
    '/images/footer/marquee/1.png',
    '/images/footer/marquee/2.png',
    '/images/footer/marquee/3.png',
    '/images/footer/marquee/4.png',
    '/images/footer/marquee/5.png',
  ];

  return (
    <div className='relative flex h-[50rem] w-full flex-row items-center justify-center overflow-hidden'>
      <Marquee pauseOnHover vertical className='[--duration:20s]'>
        {images.map((review) => (
          <div key={review} className='relative flex-shrink-0 overflow-clip rounded-3xl'>
            <div className='pointer-events-none absolute inset-0 z-10 bg-black/40' />
            <ImageWithPlaceholder src={review} alt='' className='h-[20rem] w-full object-cover' />
          </div>
        ))}
      </Marquee>
      <Marquee reverse pauseOnHover vertical className='[--duration:20s]'>
        {images.map((review) => (
          <div key={review} className='relative flex-shrink-0 overflow-clip rounded-3xl'>
            <div className='pointer-events-none absolute inset-0 bg-black/40' />
            <ImageWithPlaceholder src={review} alt='' className='h-[20rem] w-full object-cover' />
          </div>
        ))}
      </Marquee>

      <div className='from-body pointer-events-none absolute inset-x-0 top-0 h-1/4 bg-gradient-to-b backdrop-blur-sm'></div>
      <div className='from-body pointer-events-none absolute inset-x-0 bottom-0 h-1/4 bg-gradient-to-t backdrop-blur-sm'></div>
    </div>
  );
};

export default MarqueeSection;
